import routerOptions0 from "/usr/src/app/content/n3-redirections-spa-5694e709-9921-4eb8-931f-235b9cf1abcf/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}